import { Link } from 'react-router-dom';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/articles';

export default function LatestUpdates() {
  const latest = [...articles].sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  );

  return (
    <section className="py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">最新更新</h2>
          </div>
          <span className="text-xs text-foreground-500 bg-background-100 px-3 py-1 rounded-full whitespace-nowrap">
            每日更新 · 收藏不迷路
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 space-y-4">
            {latest.slice(0, 6).map((article) => (
              <ArticleCard key={article.id} article={article} variant="horizontal" />
            ))}
          </div>

          <div className="lg:col-span-1">
            <div className="bg-background-100 rounded-lg p-5 sticky top-20">
              <div className="flex items-center gap-2 mb-4">
                <i className="ri-fire-line text-accent-500 text-lg"></i>
                <h3 className="text-base font-semibold text-foreground-900">热门排行</h3>
              </div>
              <div className="space-y-0">
                {latest
                  .sort((a, b) => b.reads - a.reads)
                  .slice(0, 8)
                  .map((article, index) => (
                    <Link
                      key={article.id}
                      to={`/article/${article.id}`}
                      className="flex items-center gap-3 py-3 border-b border-background-200/70 last:border-b-0 group cursor-pointer"
                    >
                      <span
                        className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold ${
                          index < 3
                            ? 'bg-accent-500 text-background-50'
                            : 'bg-background-200 text-foreground-500'
                        }`}
                      >
                        {index + 1}
                      </span>
                      <div className="flex-1 min-w-0">
                        <h4 className="text-sm text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                          {article.title}
                        </h4>
                        <span className="text-xs text-foreground-500">{article.reads.toLocaleString()} 阅读</span>
                      </div>
                    </Link>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}